package org.example.newportfolio.utils


object Res {

    object Strings {
        const val START_SECTION_TITLE = "Software Engineer & Product Builder"
        const val START_SECTION_SUBTITLE = "I build complete software products end‑to‑end — web, mobile, backend, and Shopify apps."
        const val START_SECTION_BUTTON_TEXT = "Explore my works"
        const val SCROLL_HINT = "Scroll"

        const val WORKS_SECTION_TITLE = "Explore my works"
        const val WORKS_SECTION_SUBTITLE = "Client products and my own software — native & cross‑platform apps live on the App Store and Google Play, full‑stack platforms, and Shopify apps — built with Kotlin, Flutter, KMP, Laravel and Remix/TypeScript."

        const val ABOUT_SECTION_TITLE = "About me"
        // Full positioning: end-to-end product engineer (analysis → UI/UX →
        // backend → web → mobile → QA) who also ships his own Shopify apps & SaaS.
        const val ABOUT_SECTION_SUBTITLE = "I'm a software engineer who takes products end‑to‑end — analysis, UI/UX, backend, web, and mobile (Kotlin, Compose, KMP, Flutter, Laravel) — with a QA/SDET background for reliability. I also design and ship my own Shopify apps and SaaS (Remix, TypeScript, GraphQL). I care about clean architecture, scalable code, and real performance & UX."

        const val CONTACT_SECTION_TITLE = "Let's Build Your Idea"
        const val CONTACT_SECTION_SUBTITLE = "As a Software Engineer, I partner with a network of professionals to turn your vision into a complete, published product from zero to launch. Contact me today to get started."

        const val EMAIL_ADDRESS = "mohamed.abdelazim.elgohary@gmail.com"
        const val TELEGRAM_USERNAME = "@MohamedElgohary88"

        const val EMAIL_LINK = "mailto:$EMAIL_ADDRESS"
        const val GITHUB_LINK = "https://github.com/MohamedElgohary88"
        const val CV_LINK = "Mohamed_Elgohary_Mobile_Developer.pdf"
        const val TELEGRAM_LINK = "https://t.me/MohamedElgohary88"
        const val LINKEDIN_LINK = "https://www.linkedin.com/in/mohamed-elgohary8"

        const val COPYRIGHT = "© 2026, Mohamed Elgohary"
    }

    object FontFamilies {
        const val POPPINS_REGULAR = "PoppinsRegular"
        const val POPPINS_MEDIUM = "PoppinsMedium"
    }

    object Images {
        const val LOGO_DARK = "images/logo_dark.svg"
        const val LOGO_LIGHT = "images/logo_light.svg"

        const val START_IMAGE = "images/start_image.svg"
        // Hero photo: transparent-background cutouts (the original me-dark.webp /
        // me-light.webp had a dark brown studio backdrop that read as a hard
        // business-card rectangle on the page). Generated via `rembg` (u2net
        // model). The non-cutout originals remain on disk for the og:image
        // social previews where a backdrop reads better than a floating head.
        const val ME_DARK = "images/me-dark-cutout.webp"
        const val ME_LIGHT = "images/me-light-cutout.webp"

        const val ANDROID_STUDIO = "images/android_studio.svg"
        const val KOTLIN = "images/kotlin.svg"
        const val KTOR = "images/ktor.svg"
        const val FIGMA = "images/figma.svg"
        const val INTELLIJ_IDEA = "images/intellij_idea.svg"
        const val JAVA = "images/java.svg"
        const val FIREBASE = "images/firebase.svg"
        const val POSTGRESQL = "images/postgresql.svg"
        const val JETPACK_COMPOSE = "images/compose.svg"
        const val GITHUB_LIGHT = "images/github_light.svg"
        const val GITHUB_DARK = "images/github_dark.svg"
        const val MAIL_LIGHT = "images/mail_light.svg"
        const val MAIL_DARK = "images/mail_dark.svg"
        const val TELEGRAM_LIGHT = "images/telegram_light.svg"
        const val TELEGRAM_DARK = "images/telegram_dark.svg"
        const val LINKEDIN_LIGHT = "images/linkedin_light.svg"
        const val LINKEDIN_DARK = "images/linkedin_dark.svg"

        const val HONEY_MART = "images/hony.webp"
        const val TEAMIX = "images/teamix.webp"
        const val SKY_CAST = "images/weather.webp"
        const val MOVIE = "images/movie.webp"
        const val BLOG = "images/blog.webp"
        const val HOTEL = "images/hotel.webp"
        const val BISMAR = "images/bismar.webp"
        const val RAMTEX = "images/ramtex.webp"
        const val PURELY = "images/purely.webp"
        const val CREPE_WAFFLE = "images/crepe_waffle.webp"

        // Event Lens (عدسة المناسبات) — iOS client app + web operations dashboard
        const val EVENTLENS_APP_1 = "images/eventlens_app_1.webp"
        const val EVENTLENS_APP_2 = "images/eventlens_app_2.webp"
        const val EVENTLENS_APP_3 = "images/eventlens_app_3.webp"
        const val EVENTLENS_DASH_1 = "images/eventlens_dash_1.webp"
        const val EVENTLENS_DASH_2 = "images/eventlens_dash_2.webp"

        // Ramtex — full-stack distribution platform: customer / field-sales /
        // driver mobile apps + enterprise web dashboard
        const val RAMTEX_APP_1 = "images/ramtex_app_1.webp"
        const val RAMTEX_APP_2 = "images/ramtex_app_2.webp"
        const val RAMTEX_APP_3 = "images/ramtex_app_3.webp"
        const val RAMTEX_DASH_1 = "images/ramtex_dash_1.webp"
        const val RAMTEX_DASH_2 = "images/ramtex_dash_2.webp"
        const val RAMTEX_DASH_3 = "images/ramtex_dash_3.webp"

        const val POST_SYNC = "images/postsync.webp"
        const val VARIANT_CAST = "images/variantcast.svg"
        const val AI_DESCRIPTIONS = "images/ai-descriptions.svg"
        const val INVENTORY_ALERTS = "images/inventory-alerts.svg"
        const val RETURNS_AUTOMATION = "images/returns-automation.svg"
        
        const val VARIANT_CAST_1 = "images/variantcast_1.png"
        const val VARIANT_CAST_2 = "images/variantcast_2.png"
        const val AI_DESCRIPTIONS_1 = "images/ai_descriptions_1.png"
        const val AI_DESCRIPTIONS_2 = "images/ai_descriptions_2.png"
        const val INVENTORY_ALERTS_1 = "images/inventory_alerts_1.png"
        const val INVENTORY_ALERTS_2 = "images/inventory_alerts_2.png"
        const val RETURNS_AUTOMATION_1 = "images/returns_automation_1.png"
        const val RETURNS_AUTOMATION_2 = "images/returns_automation_2.png"
        
        const val FLUTTER = "images/flutter.svg"
        const val DART = "images/dart.svg"
        const val GRADLE = "images/gradle.svg"
        const val GRAPHQL = "images/graphql.svg"
        const val REALM = "images/realm.svg"
        const val SQLITE = "images/sqlite.svg"
        const val MONGODB = "images/mongodb.svg"
        const val POSTMAN = "images/postman.svg"
        const val GITLAB = "images/git_lab.svg"
        const val SWIFT = "images/swift.svg"
        const val APPLE = "images/apple.svg"
        const val ADOBE_XD = "images/adobe_xd.svg"
        const val SLACK = "images/slack.svg"
    }
}